import { render, staticRenderFns } from "./DentatsuMail.vue?vue&type=template&id=697dd738&scoped=true&"
import script from "./DentatsuMail.vue?vue&type=script&lang=js&"
export * from "./DentatsuMail.vue?vue&type=script&lang=js&"
import style0 from "./DentatsuMail.vue?vue&type=style&index=0&id=697dd738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697dd738",
  null
  
)

export default component.exports